import React from 'react'
import type { ExperienceOfferPageDispatchAction } from './experienceOfferPageStateReducer'
import noop from 'lib/function/noop'

const ExperienceOfferPageDispatchContext = React.createContext<React.Dispatch<ExperienceOfferPageDispatchAction>>(noop)

export default ExperienceOfferPageDispatchContext
